import React from "react";
function Home(props) {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "90vh" }}
    >
      Home
    </div>
  );
}

export default Home;
